
const studentStatusEnum = {
  ALL: {
    code: 0,
    name: "ALL",
    desc: "全部",
    kind: "studentStatus"
  },
  UPLOAD: {
    code: 1,
    name: "UPLOAD",
    desc: "已上传",
    kind: "studentStatus"
  },
  UN_UPLOAD: {
    code: 2,
    name: "MULTI_CHOICE",
    desc: "班级未上传",
    kind: "studentStatus"
  },
  NO_NAME_PAPER: {
    code: 3,
    name: "NO_NAME_PAPER",
    desc: "无名卷",
    kind: "studentStatus"
  },
  ABSENT: {
    code: 4,
    name: "ABSENT",
    desc: "缺考",
    kind: "studentStatus"
  },
  EXEMPT_EXAM: {
    code: 5,
    name: "EXEMPT_EXAM",
    desc: "免考",
    kind: "studentStatus"
  },
  ZERO: {
    code: 6,
    name: "ZERO",
    desc: "0分卷",
    kind: "studentStatus"
  },
  UN_STATISTICS: {
    code: 7,
    name: "UN_STATISTICS",
    desc: "不参与统计",
    kind: "studentStatus"
  },
  UN_UPLOAD_HAS_CHOOSE_SUBJECT: {
    code: 9,
    name: "UN_STATISTICS",
    desc: "学科未上传",
    kind: "studentStatus"
  },
  UPLOAD_NOT_CHOOSE_SUBJECT: {
    code: 10,
    name: "UN_STATISTICS",
    desc: "未选科",
    kind: "studentStatus"
  },
}

export default Object.freeze(studentStatusEnum)